import request from '@host-panel/request';

export function resetMetadata({
  url,
  spotId,
  conversationId
}: Partial<{ url: string; spotId: string; conversationId: string }>): Promise<{
  success: boolean;
}> {
  return request('/host-panel/metadata/reset', {
    method: 'POST',
    data: {
      ...(spotId && { reset_spot_id: spotId }),
      ...(conversationId && { reset_conversation_id: conversationId }),
      ...(url && { reset_url: url })
    }
  });
}
